import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// DO NOT REMOVE THIS LINE 
// eslint-disable-next-line no-unused-vars
import i18n from './utils/i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);